import IconArrowUpRightFromSquareSolid from '@/assets/icons/font_awesome/arrow-up-right-from-square-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';

interface Props {
  url: string;
}

export function WSWorkspaceChildEntityOpenButton({ url }: Props) {
  function onClick() {
    window.open(url, '_blank');
  }

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      className="!w-7 !h-7 p-0"
      iconClassNameBase="!text-component-item-foreground !size-3"
      iconClassNameHovered="!text-bar-foreground"
      variant={'no-border-on-component'}
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      Icon={IconArrowUpRightFromSquareSolid}
      {...{ onClick }}
    />
  );
}
